import React, { useState } from 'react';
import { Button, Drawer, Space } from 'antd';

const SideDrawer = ({buttonText,drawerTitle,buttonType,children,onDrawerClose}) => {
  const [open, setOpen] = useState(false);

  const openDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
    if(onDrawerClose){
      onDrawerClose()
    }
  };
  return (
    <>
      <Space>
        <Button type={buttonType} onClick={openDrawer}>
          {buttonText}
        </Button>
      </Space>
      <Drawer
        title={drawerTitle}
        placement="right"
        size={'large'}
        onClose={onClose}
        visible={open}
        extra={
          <Space>
            <Button onClick={onClose}>Cancel</Button>
            {/* <Button type="primary" onClick={onClose}>
              Submit
            </Button> */}
          </Space>
        }
      >
        {children}
      </Drawer>
    </>
  );
};
export default SideDrawer;